export default __webpack_public_path__ + "static/media/sheet_thumb03_babycarerecord@2x.221cd907.png";